import Tooltip from "./Tooltip";

const NormalTooltip = () => (
  <Tooltip>
    <h1>Normal mode</h1>
    <p>
      The aim of "I'm closer than you" is to discard all 98 cards in the deck
      onto four discard piles in order to win, but there are some rules to
      follow.
    </p>
    <p>
      Each player starts with 6-8 cards in their hand depending on the number of
      players, and four discard pile prompt cards are on the table: two showing
      "1" and an up arrow and two showing "100" and a down arrow. On a turn, a
      player must discard at least two cards from their hand onto one or more
      discard piles, with cards on the 1 piles being placed in ascending order
      and cards on the 100 piles being placed in descending order.
    </p>
    <p>
      One tricky aspect of the game is that you can play a card exactly 10
      higher/lower than the top card of a discard pile even when you would
      normally have to play in a descending/ascending order, e.g., if a 100
      discard pile is topped with an 87, you can play any card lower than 87 or
      you can play the 97.
    </p>
    <p>
      After a player finishes their turn, they refill their hand from the deck.
      During play, players cannot reveal exact numbers in their hands, but they
      can tell the others that they are "interested" in certain discard piles.
    </p>
    <p>
      Once the deck is emptied, players are required only to play at least one
      card on a turn. If you play all 98 cards, you win!
    </p>
  </Tooltip>
);

export default NormalTooltip;
